export default __webpack_public_path__ + "static/media/sxanpro-logo.9476cf2a.svg";